/**
 * 进行业务的封装，对通用返回结果做处理
 */

import { get as _get, post as _post, init } from './libs/request'
import { loadVtools as _loadVtools, loadConfig as loadConf } from './libs/vtools'
import { checkIsElkReport, checkShouldSkipReport } from './libs/elk';
import { elk, acc } from './report';
import { isObject, isUndefined } from './type';
import { paramsToObject, getCGIName, to } from './util';
import { getAlarmCfgVal, alarm } from './alarm';
import { getLocale } from "./locale";

function get(...arg) {
    const startTime = new Date().getTime();
    let p = _get(...arg);
    p = p.then((res) => {
        return dataPreHandler(res, startTime);
    });
    // 捕获404等异常
    p = p.catch((err) => {
        return requestFailError(err, arguments);
    });
    p = p.then(commonHandler);
    return p;
}

function post(...arg) {
    const startTime = new Date().getTime();
    let p = _post(...arg);
    p = p.then((res) => {
        return dataPreHandler(res, startTime);
    });
    // 捕获404等异常
    p = p.catch((err) => {
        return requestFailError(err, arguments);
    });
    p = p.then(commonHandler);
    return p;
}

/**
 * 加载vtools文件
 * @param url
 * @param expire
 * @returns {*}
 */
function loadVtools(url, expire = 0) {
  const startTime = new Date().getTime();
    let p = _loadVtools(url, expire);
    p = p.then(data => {
        return data;
    });
    // 捕获404等异常
    p = p.catch((err) => {
        return requestFailError(err, [url])
    });
    p = p.finally(() => {
        if(url) {
            const [urlPath, urlParams] = url.split('?');
            elk({
              key: 'load_vtools_request',
              str1: urlPath,
              timeDiff: new Date().getTime() - startTime,
              url,
              msg: urlParams ? `request config params: ${urlParams}` : ''
          })
        }
    });    
    return p;
}

/**
 * 加载配置文件
 * 说明：和loadVtools不同，该方法默认不会给请求加上时间戳，建议优先使用协商缓存
 * @param {string} url 请求的配置URL
 * @param {object} [options] 相关选项
 * @param {boolean} options.isIgnoreHttpCache 是否忽略http缓存，默认false（为true时请求会携带随机参数，每次都下载最新配置）
 * @returns 
 */
async function loadConfig(url, options) {
    const { isIgnoreHttpCache = false } = options || {};
    const [err, res] = await to(loadConf(url, isIgnoreHttpCache));
    if (err) {
        return await requestFailError(err, [url])
    }
    return res.data;
}

function getDataLength(data) {
    let length = 0;
    try {
        length = JSON.stringify(data).length
    } catch (e) {
        length = data ? data.length : 0
    }
    return length;
}


function commonHandler(data) {
    const retcode = parseInt(getRetCode(data));
    if (!Number.isInteger(retcode)) { // 解析有问题等，统一报网络异常
        return networkError(data);
    }
    switch (retcode) {
        case 0:
            return data;
        // case 51001000:
        // case 51001001:
        // case 51001095:
        // case 51001096:
        // case 51001097:
        //     // 没有登录
        //     return onNotLogin(data);
        default:
            return otherError(data);
    }
}

function onNotLogin(data) {
    // 未登录处理
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            //todo展示未登录toast
            reject(data);
        }, 1000);
    })
}

function requestFailError(err, arg) {
    const isElkReport = checkIsElkReport(getRequestUrl(arg));
    if (!isElkReport) {
        // 过滤调elk上报异常情况
        reportErrorData(err);
    }
    return networkError(err);
}


function otherError(data) {
    //其他异常处理
    return Promise.reject(data);
}
/**
 * 网络异常
 */
function networkError(error) {
    return Promise.reject({
        retmsg: getLocale('网络异常，请稍后再试'),
        error
    });
}

/**
 * 数据预处理
 * @param res
 */
function dataPreHandler(res, startTime) {

    if (!checkShouldSkipReport(res.config)) {
        // 如果url带有不上报标志 直接跳过 否则上报
        reportData(res, startTime);
    }
    return res.data;
}

function getRequestUrl(arg) {
    return arg && arg[0];
}

/**
 * 获取后端返回码
 * @param data
 * @returns {number|*|string|String|string}
 */
function getRetCode(data) {
    if (!isObject(data)) {
        return '';
    }
    const arr = [data.retcode, data.errCode];
    for (const i in arr) {
        const code = arr[i];
        if (!isUndefined(code)) return code;
    }
    return '';
}

/** 密码入参格式化 */
function formatPwdParams(pwd) {
  if (typeof pwd !== 'string') return '';
  return pwd.slice(0,4) + '*';
}

/**
 * elk异步上报数据
 * @param res
 */
function reportData(res, startTime) {
    setTimeout(() => {
        const config = res.config || {};
        const data = res.data || {};
        const url = config.url || '';
        const cgiName = getCGIName(url);
        const cost = new Date().getTime() - startTime;
        const retcode = getRetCode(data);
        const reqObj = paramsToObject(config.data);

        //过滤掉密码参数，太长了
        if (reqObj.pay_pwd) {
            //干掉pay_pwd
            reqObj.pay_pwd = formatPwdParams(reqObj.pay_pwd);
        }
        if (reqObj.pin) {
            //干掉pin
            reqObj.pin = formatPwdParams(reqObj.pin);
        }
        if (reqObj.pwd) {
            //干掉pwd
            reqObj.pwd = formatPwdParams(reqObj.pwd);
        }

        if (getAlarmCfgVal('listenRequest')) {
            alarm({
                /* service */
                name: cgiName,
                /* 请求耗时  微秒 */
                // cost: cost * 1000,
                /* 错误码 */
                retcode: retcode,
                level: '10min_50times',
                message: 'request模块请求响应',
            });
        } else {
            acc({
                /* service */
                service: cgiName,
                /* 请求耗时  微秒 */
                cost: cost * 1000,
                /* 错误码 */
                retcode: retcode,
            });
        }

        elk({
            errCode: retcode,
            msg: data,
            method: config.method,
            url: config.url,
            body: reqObj,
            key: cgiName,
            timeDiff: new Date().getTime() - startTime,
            str1: data.retmsg || '',
            str2: 'ajax',
            str4: config.params// str3是关键字 所以用4
        });
    });
}

/**
 * elk异步上报异常数据
 * @param res
 */
function reportErrorData(res) {
    setTimeout(() => {
        const config = res.config || {};
        const data = res.data || res.message || {};
        const url = config.url || '';
        const cgiName = getCGIName(url);

        if (getAlarmCfgVal('listenRequest')) {
            alarm({
                /* service */
                name: cgiName,
                /* 错误码 */
                retcode: res && res.response && res.response.status || 0,
                level: '10min_50times',
                message: 'request模块请求失败',
            });
        } else {
            acc({
                /* service */
                service: cgiName,
                /* 错误码 */
                retcode: res && res.response && res.response.status || 0,
                ext1: 'ajaxError'
            });
        }

        elk({
            errCode: res && res.response && res.response.status,
            msg: data,
            url: config.url,
            body: config.data || '',
            key: 'ajaxError'
        });
    })
}

export default {
    init,
    get,
    post,
    loadVtools,
    loadConfig
}
